export default __webpack_public_path__ + "img/cd739c6d1bec71bb46981dd535ff94c8.svg";